import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'animate.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';
import { AppProvider } from './contexts/AppContext';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider } from '@swat-sccs/react-simple-snackbar';
import { ParamsProvider } from './contexts/ParamsContext';
import { NotificationsProvider } from './notifications/NotificationsContext';
import { EstabsProvider } from './contexts/EstabsContext';
import { FilterAppProvider } from './contexts/FilterApp';
import { TourProvider } from './contexts/TourContext';
import { initializeClarity } from './clarity';

initializeClarity();

if (process.env.NODE_ENV === 'development') {
    const resizeObserverMessages = [
        'ResizeObserver loop completed with undelivered notifications.',
        'ResizeObserver loop limit exceeded',
    ];

    window.addEventListener(
        'error',
        (event) => {
            if (resizeObserverMessages.includes(event.message)) {
                event.stopImmediatePropagation();
                event.preventDefault();
            }
        },
        true
    );

    const suppressedMessages = [
        'Warning: TicksLayout: Support for defaultProps will be removed from function components',
        'Warning: TickCell: Support for defaultProps will be removed from function components',
        'Warning: Indicator: Support for defaultProps will be removed from function components',
    ];

    const originalConsoleError = console.error;
    console.error = (...args: unknown[]) => {
        const combinedText = args
            .map((arg) => {
                if (typeof arg === 'string') return arg;
                try {
                    return JSON.stringify(arg);
                } catch {
                    return String(arg);
                }
            })
            .join(' ');
        const shouldSuppress = suppressedMessages.some((message) => combinedText.includes(message));
        if (shouldSuppress) return;
        originalConsoleError(...args);
    };
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <ParamsProvider>
                <SnackbarProvider>
                    <AuthProvider>
                        <AppProvider>
                            <EstabsProvider>
                                <NotificationsProvider>
                                    <FilterAppProvider>
                                        <TourProvider>
                                            <App />
                                        </TourProvider>
                                    </FilterAppProvider>
                                </NotificationsProvider>
                            </EstabsProvider>
                        </AppProvider>
                    </AuthProvider>
                </SnackbarProvider>
            </ParamsProvider>
        </BrowserRouter>
    </React.StrictMode>
);
reportWebVitals();
